import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss'],
  standalone: false,
})
export class AdminPanelComponent {
  public readonly navigationItems = [
    {
      route: 'companies',
      labelKey: 'COMPONENTS.ADMIN_PANEL.NAV.COMPANIES',
      descriptionKey: 'COMPONENTS.ADMIN_PANEL.NAV.COMPANIES_DESCRIPTION',
    },
    {
      route: 'access-history',
      labelKey: 'COMPONENTS.ADMIN_PANEL.NAV.ACCESS_HISTORY',
      descriptionKey: 'COMPONENTS.ADMIN_PANEL.NAV.ACCESS_HISTORY_DESCRIPTION',
    },
    {
      route: 'admins',
      labelKey: 'COMPONENTS.ADMIN_PANEL.NAV.ADMINS',
      descriptionKey: 'COMPONENTS.ADMIN_PANEL.NAV.ADMINS_DESCRIPTION',
    },
  ];
}
